import { render, staticRenderFns } from "./changes.vue?vue&type=template&id=a4b99ec0&"
import script from "./changes.vue?vue&type=script&lang=js&"
export * from "./changes.vue?vue&type=script&lang=js&"
import style0 from "./changes.vue?vue&type=style&index=0&id=a4b99ec0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports